// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HammerOutlinedSvg from "@fishx/icons-svg/es/asn/HammerOutlined";
import FishxIcon from '../components/FishxIcon';

var HammerOutlined = function HammerOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HammerOutlinedSvg
  }));
};

HammerOutlined.displayName = 'HammerOutlined';
export default React.forwardRef(HammerOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HammerOutlined.js
// module id = 2910
// module chunks = 0